import { useQuery } from '@tanstack/react-query'
import { knowledgeFunctions } from '../../api/modules/knowledgeApi'
import { KnowledgeSite } from '../../core/client/ClientProvider'

const VISIBLE_SOURCES_QUERY_KEY = ['knowledge', 'visible-sources']

/**
 * Fetch the toggleable knowledge sources visible to the current user from
 * `GET /api/knowledge/visible-sources`. Mirrors {@link useCommands}
 * (react-query, generous `staleTime`). Replaces the build-time
 * `toggleable_knowledge_sites` config, which leaked restricted source names.
 */
export function useVisibleKnowledgeSites(enabled = true) {
  const { data: sites = [], isLoading } = useQuery<KnowledgeSite[]>({
    queryKey: VISIBLE_SOURCES_QUERY_KEY,
    queryFn: () => knowledgeFunctions.fetchVisibleSources(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled,
  })

  return { sites, isLoading }
}
